// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".four[data-v-13cd16b5]{margin:5.20833vw auto;font-size:1.5625vw}.four h2[data-v-13cd16b5]{font-size:2.08333vw}", ""]);
// Exports
module.exports = exports;
